<template>
    <div :style="`min-height:${height};`" class="is-relative">
        <bubble-menu
            v-if="editor && editable"
            v-show="editor.isActive('link')"
            :editor="editor"
            :tippy-options="{ duration: 100 }"
        >
            <div class="bubble-menu">
                <form class="menububble__form" @submit.prevent="setLinkUrl">
                    <input
                        ref="linkInput"
                        v-model="linkUrl"
                        class="menububble__input"
                        type="text"
                        placeholder="https://"
                    />
                    <button
                        class="menububble__button"
                        type="button"
                        @click="editor.chain().focus().unsetLink().run()"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-trash" />
                        </span>
                    </button>
                </form>
            </div>
        </bubble-menu>
        <div
            v-if="editable"
            :style="'width:100%;'"
            class="buttons has-background-light is-inline-block"
        >
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('heading', { level: 1 }),
                }"
                class="button has-background-light"
                @click="
                    editor.chain().focus().toggleHeading({ level: 1 }).run()
                "
            >
                h1
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('heading', { level: 2 }),
                }"
                class="button has-background-light"
                @click="
                    editor.chain().focus().toggleHeading({ level: 2 }).run()
                "
            >
                h2
            </button>
            <button
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('bold'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleBold().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-bold" />
                </span>
            </button>
            <button
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('italic'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleItalic().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-italic" />
                </span>
            </button>
            <button
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('underline'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleUnderline().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-underline" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('highlight'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleHighlight().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-highlighter" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('link'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().setLink().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-link" />
                </span>
            </button>
            <button
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('bulletList'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleBulletList().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-list-ul" />
                </span>
            </button>

            <button
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('orderedList'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleOrderedList().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-list-ol" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive('blockquote'),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().toggleBlockquote().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-quote-right" />
                </span>
            </button>
            <!--a
            :class="{
              'is-selected is-primary has-background-dark': isActive.code_block(),
            }"
            class="button has-background-light"
            @click="commands.code_block"
          >
            <span class="icon is-small">
              <i class="fas fa-code" />
            </span>
          </a-->
            <button
                v-if="advancedOptions"
                class="button has-background-light"
                @click="editor.chain().focus().setHorizontalRule().run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-grip-lines" />
                </span>
            </button>

            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive({
                            textAlign: 'left',
                        }),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().setTextAlign('left').run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-align-left" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive({
                            textAlign: 'center',
                        }),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().setTextAlign('center').run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-align-center" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive({
                            textAlign: 'right',
                        }),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().setTextAlign('right').run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-align-right" />
                </span>
            </button>
            <button
                v-if="advancedOptions"
                :class="{
                    'is-selected is-primary has-background-dark':
                        editor.isActive({
                            textAlign: 'justify',
                        }),
                }"
                class="button has-background-light"
                @click="editor.chain().focus().setTextAlign('justify').run()"
            >
                <span class="icon is-small">
                    <i class="fas fa-align-justify" />
                </span>
            </button>
        </div>
        <editor-content :editor="editor" class="editor__content" />
    </div>
</template>

<script>
import { Editor, EditorContent, BubbleMenu, VueRenderer } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Highlight from '@tiptap/extension-highlight';
import Heading from '@tiptap/extension-heading';
import TextAlign from '@tiptap/extension-text-align';
import Mention from '@tiptap/extension-mention';
import tippy from 'tippy.js';
import AppMentionsDropdown from '@/components/AppMentionsDropdown';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import { EventBus } from '@/services/event-bus';
export default {
    components: {
        EditorContent,
        BubbleMenu,
    },
    model: {
        prop: 'content',
    },
    props: {
        content: {
            type: String,
            default: '', // $t("creation.description_hint")
        },
        placeholder: {
            type: String,
            default: '',
        },
        editable: {
            type: Boolean,
            default: true,
        },
        advancedOptions: {
            type: Boolean,
            default: false,
        },
        suggestions: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            editor: new Editor({
                autofocus: this.editable,
                content: this.content,
                editable: this.editable,
                extensions: [
                    Document,
                    Paragraph,
                    Text,
                    Underline,
                    Link,
                    Highlight,
                    StarterKit,
                    TextAlign.configure({ types: ['heading', 'paragraph'] }),
                    Table.configure({
                        resizable: true,
                    }),
                    TableRow,
                    TableHeader,
                    TableCell,
                    Mention.configure({
                        HTMLAttributes: {
                            class: 'mention',
                        },
                        suggestion: {
                            items: (query) => {
                                return this.suggestions
                                    .filter((item) =>
                                        item.username
                                            .toLowerCase()
                                            .startsWith(
                                                query.query.toLowerCase()
                                            )
                                    )
                                    .slice(0, 5);
                            },
                            render: () => {
                                /*if (!this.suggestions.length) {
                                    return;
                                }*/
                                let component;
                                let popup;

                                return {
                                    onStart: (props) => {
                                        component = new VueRenderer(
                                            AppMentionsDropdown,
                                            {
                                                parent: this,
                                                propsData: {
                                                    ...props,
                                                    ...{ loading: false },
                                                },
                                            }
                                        );

                                        popup = tippy('body', {
                                            getReferenceClientRect:
                                                props.clientRect,
                                            appendTo: () => document.body,
                                            content: component.element,
                                            showOnCreate: true,
                                            interactive: true,
                                            trigger: 'manual',
                                            placement: 'bottom-start',
                                        });
                                    },
                                    onUpdate(props) {
                                        component.updateProps(props);
                                        popup[0].setProps({
                                            getReferenceClientRect:
                                                props.clientRect,
                                        });
                                    },
                                    onKeyDown(props) {
                                        if (component.ref)
                                            return component.ref.onKeyDown(
                                                props
                                            );
                                    },
                                    onExit() {
                                        popup[0].destroy();
                                        component.destroy();
                                    },
                                };
                            },
                        },
                    }),
                    Heading.extend({
                        levels: [1, 2],
                        renderHTML({ node, HTMLAttributes }) {
                            const level = node.attrs.level;
                            const classes = {
                                1: 'is-size-4',
                                2: 'is-size-5 is-italic',
                            };

                            return [
                                `h${level}`,
                                {
                                    ...HTMLAttributes,
                                    ...{ class: `title ${classes[level]}` },
                                },
                                0,
                            ];
                        },
                    }),
                    Placeholder.configure({
                        showOnlyCurrent: false,
                        emptyEditorClass: 'editor-empty',
                        placeholder: () => {
                            if (!this.placeholder) {
                                return this.$t(
                                    'creation.description_placeholder'
                                );
                            }
                            return this.placeholder;
                        },
                    }),
                ],
                onUpdate: this.updateText,
            }),
            linkUrl: null,
            height: '80px',
        };
    },
    watch: {
        content(e) {
            if (!e.length) {
                this.editor && this.editor.commands.clearContent();
            } else {
                if (this.editor.getHTML() != e) {
                    this.editor.commands.setContent(e);
                }
            }
        },
        editable() {
            this.editor.setOptions({
                editable: this.editable,
            });
        },
    },
    mounted() {
        this.setAutoHeight();
        EventBus.$on('layout:changed', this.setAutoHeight);
    },
    beforeDestroy() {
        // Always destroy your editor instance when it's no longer needed
        this.editor && this.editor.destroy();
        EventBus.$off('layout:changed', this.setAutoHeight);
    },
    methods: {
        updateText() {
            this.$emit('input', this.editor.getHTML());
            this.setAutoHeight();
        },
        setAutoHeight() {
            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.editor) {
                        this.height = `${this.editor.view.dom.scrollHeight}px`;
                        this.$emit('resize', {
                            height: this.editor.view.dom.scrollHeight,
                        });
                    }
                });
            }, 100);
        },
        setLinkUrl(command, url) {
            this.editor.chain().focus().setLink({ href: this.linkUrl }).run();
        },
    },
};
</script>

<style scoped>
.button {
    border: none;
}
</style>

<style lang="scss" scoped>
::v-deep {
    /* Basic editor styles */
    .ProseMirror {
        min-height: 80px;
        > * + * {
            margin-top: 0.75em;
        }
        ul,
        ol {
            padding: 0 1rem;
        }
        code {
            background-color: rgba(#616161, 0.1);
            color: #616161;
        }
        pre {
            background: #0d0d0d;
            color: #fff;
            font-family: 'JetBrainsMono', monospace;
            padding: 0.75rem 1rem;
            border-radius: 0.5rem;
            code {
                color: inherit;
                padding: 0;
                background: none;
                font-size: 0.8rem;
            }
        }
        img {
            max-width: 100%;
            height: auto;
        }
        blockquote {
            padding-left: 1rem;
            border-left: 2px solid rgba(#0d0d0d, 0.1);
        }
        hr {
            border: none;
            border-top: 2px solid rgba(#0d0d0d, 0.1);
            margin: 2rem 0;
        }
    }

    .ProseMirror:focus {
        outline: none;
    }

    /* Placeholder (at the top) */
    .ProseMirror p.is-empty:first-child::before {
        content: attr(data-placeholder);
        float: left;
        color: #ced4da;
        pointer-events: none;
        height: 0;
    }

    /* Placeholder (on every new line) */
    /*.ProseMirror p.is-empty::before {
    content: attr(data-placeholder);
    float: left;
    color: #ced4da;
    pointer-events: none;
    height: 0;
  }*/

    a {
        color: #68cef8;
    }
}
</style>

<style scoped lang="scss">
.buttons > .button:not(:last-child) {
    margin-left: 0.5rem !important;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.bubble-menu {
    display: flex;
    background-color: #0d0d0d;
    padding: 0.2rem;
    border-radius: 0.5rem;

    button {
        border: none;
        background: none;
        color: #fff;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.2rem;
        opacity: 0.6;

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}

.menububble {
    position: absolute;
    display: flex;
    z-index: 20;
    background: black;
    border-radius: 5px;
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;

    &.is-active {
        opacity: 1;
        visibility: visible;
    }

    &__button {
        display: inline-flex;
        background: transparent;
        border: 0;
        color: white;
        padding: 0.2rem 0.5rem;
        margin-right: 0.2rem;
        border-radius: 3px;
        cursor: pointer;

        &:last-child {
            margin-right: 0;
        }

        &:hover {
            background-color: rgba(white, 0.1);
        }

        &.is-active {
            background-color: rgba(white, 0.2);
        }
    }

    &__form {
        display: flex;
        align-items: center;
    }

    &__input {
        font: inherit;
        border: none;
        background: transparent;
        color: white;
    }
}

::v-deep .ProseMirror {
    .mention {
        color: #a975ff;
        background-color: rgba(#a975ff, 0.1);
        border-radius: 0.3rem;
        padding: 0.1rem 0.3rem;
    }
    table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        margin: 0;
        overflow: hidden;

        td,
        th {
            min-width: 1em;
            border: 2px solid #ced4da;
            padding: 3px 5px;
            vertical-align: top;
            box-sizing: border-box;
            position: relative;

            > * {
                margin-bottom: 0;
            }
        }

        th {
            font-weight: bold;
            text-align: left;
            background-color: #f1f3f5;
        }

        .selectedCell:after {
            z-index: 2;
            position: absolute;
            content: '';
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(200, 200, 255, 0.4);
            pointer-events: none;
        }

        .column-resize-handle {
            position: absolute;
            right: -2px;
            top: 0;
            bottom: -2px;
            width: 4px;
            background-color: #adf;
            pointer-events: none;
        }
    }
}
</style>
